<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/contracts'"
            >Contracts</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Create
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <investor-contract-form
        contractType="InvestorContract"
        formType="create"
        @saveContract="createInvestorContract"
      ></investor-contract-form>
    </div>
  </div>
</template>
<script>
import InvestorContractForm from "./forms/contractForm.vue";

import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
    };
  },
  components: {
    InvestorContractForm,
  },
  methods: {
    formValidation(contract) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!contract.start_date) {
        missingFieldsString += "Contract start date is not selected, ";
        result.isValid = false;
      }
      if (!contract.maturity_date) {
        missingFieldsString += "Contract maturity date is not selected, ";
        result.isValid = false;
      }
      if (!contract.investor_id) {
        missingFieldsString += "Investor is not selected, ";
        result.isValid = false;
      }
      if (!contract.plan_id) {
        missingFieldsString += "Plan is not selected, ";
        result.isValid = false;
      }
      if (!contract.invested_principal) {
        missingFieldsString += "Principal field is empty, ";
        result.isValid = false;
      }
      let statusList = ["active", "inactive", "notstarted", "closed"];

      if (!statusList.includes(contract.status)) {
        missingFieldsString += "Contract status should be selected, ";
        result.isValid = false;
      }
      let paymentTypes = ["cash", "banktransfer", "cheque", "blockchain"];

      if (!paymentTypes.includes(contract.payment_type)) {
        missingFieldsString += "Contract payment should be selected, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    createInvestorContract(contract) {
      const { isValid, message } = this.formValidation(contract);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("createInvestorContract", contract);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      createdInvestorContract: (state) =>
        state.contractStore.investorContractCreate.createdInvestorContract,
      createInvestorContractStatus: (state) =>
        state.contractStore.investorContractCreate.createInvestorContractStatus,
      deleteInvestorContractStatus: (state) =>
        state.contractStore.investorContractDelete.deleteInvestorContractStatus,
    }),
  },
  watch: {
    createInvestorContractStatus() {
      if (this.createInvestorContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push(
            "/" + this.authUser.userable_type + "/investors/contracts"
          );
        });
      } else if (this.createInvestorContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/createInvestorContract.vue